import React from 'react';
import './EmptyState.css';

type IconName = 'profiles' | 'documents' | 'contacts' | 'heirlooms' | 'notes' | 'funeral' | 'letters';

interface Props {
  icon: IconName;
  title: string;
  subtitle?: string;
}

function IconSvg({ name }: { name: IconName }) {
  const accent = 'var(--gold-muted)';

  switch (name) {
    case 'profiles':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <circle cx="32" cy="22" r="10" stroke="currentColor" strokeWidth="2" fill={accent} />
          <path d="M12 54c0-11.046 8.954-20 20-20s20 8.954 20 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'documents':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <path d="M16 8h24l12 12v36a2 2 0 01-2 2H16a2 2 0 01-2-2V10a2 2 0 012-2z" stroke="currentColor" strokeWidth="2" fill={accent} />
          <path d="M40 8v12h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <line x1="22" y1="30" x2="42" y2="30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="22" y1="38" x2="38" y2="38" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="22" y1="46" x2="34" y2="46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'contacts':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <path d="M12 10a4 4 0 014-4h32a4 4 0 014 4v44a4 4 0 01-4 4H16a4 4 0 01-4-4V10z" stroke="currentColor" strokeWidth="2" fill={accent} />
          <circle cx="32" cy="26" r="7" stroke="currentColor" strokeWidth="2" />
          <path d="M20 46c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="8" y1="20" x2="12" y2="20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="8" y1="32" x2="12" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="8" y1="44" x2="12" y2="44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case 'heirlooms':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <polygon points="32,6 42,24 58,28 46,42 48,58 32,52 16,58 18,42 6,28 22,24" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" fill={accent} />
          <polygon points="32,18 36,28 46,30 38,38 40,48 32,44 24,48 26,38 18,30 28,28" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
        </svg>
      );
    case 'notes':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <rect x="14" y="10" width="36" height="44" rx="3" stroke="currentColor" strokeWidth="2" fill={accent} />
          <line x1="22" y1="24" x2="42" y2="24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="22" y1="32" x2="38" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="22" y1="40" x2="34" y2="40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <rect x="26" y="2" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" fill="none" />
          <circle cx="32" cy="8" r="2" fill="currentColor" />
        </svg>
      );
    case 'funeral':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          {/* Vertical beam */}
          <rect x="28" y="8" width="8" height="48" rx="2" stroke="currentColor" strokeWidth="2" fill={accent} />
          {/* Horizontal beam */}
          <rect x="14" y="20" width="36" height="8" rx="2" stroke="currentColor" strokeWidth="2" fill={accent} />
        </svg>
      );
    case 'letters':
      return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="empty-state-icon">
          <rect x="8" y="16" width="48" height="34" rx="3" stroke="currentColor" strokeWidth="2" fill={accent} />
          <path d="M8 19l24 18 24-18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
  }
}

export default function EmptyState({ icon, title, subtitle }: Props) {
  return (
    <div className="empty-state">
      <IconSvg name={icon} />
      <p className="empty-state-title">{title}</p>
      {subtitle && <p className="empty-state-subtitle">{subtitle}</p>}
    </div>
  );
}
